import React from 'react';
import PropTypes from 'prop-types';

ProjectDescriptionRow.propTypes = {
  label: PropTypes.node,
  children: PropTypes.node
};

export default function ProjectDescriptionRow(props) {
  const { label, children } = props;

  return (
    <div className="flex flex-col gap-2 px-4 py-4 md:flex-row md:items-start md:gap-4">
      <div className="text-sm leading-normal font-semibold text-cs-orange-650 md:w-40 md:shrink-0 md:pt-0.5">
        {label}
      </div>
      <div className="min-w-0 md:flex-1">{children}</div>
    </div>
  );
}
